import {TokenService} from '../services/token.service';

const RoleService = {
    inEditorRole() {
        const editorRoles = ['ITSAdmin', 'ITSEditorMedical', 'ITSEditorAPO', 'ITSEditorFinance', 'ITSEditorClo', 'ITSEditorSecurity',  'ITSEditorLogistics'];
        let inEditorRole = false;
        
        editorRoles.forEach((item) => {
          if (TokenService.getRoles().indexOf(item) >= 0) {
            inEditorRole = true;
          }
        });

        return inEditorRole;
    },

    isAdmin() {
        return TokenService.getRoles().indexOf("ITSAdmin") >= 0;
    }
}

export {RoleService}